import {Fragment, useMemo, useState} from 'react';
import {useTranslation} from 'react-i18next';

import {Button, ChangePassword, InformationModal, PasswordChangedAt} from 'components';
import {PASSWORD_CHANGE} from 'constants/images';
import {TRANSLATION_KEYS} from 'locale';
import {userAuthUtils} from 'utils';

type Props = {
    open: boolean;
    onClose: () => void;
}

enum View {
    Initial = 'initial',
    PasswordForm = 'password_form'
}

const T_KEYS = TRANSLATION_KEYS.COMPONENTS.USER_PASSWORD_EXPIRE_SOON_MODAL;

export const UserPasswordExpireSoonModal: React.FC<Props> = ({open, onClose}) => {
    const {t} = useTranslation();

    const localUser = useMemo(() => userAuthUtils.getLocalUser(), []);
    const [view, setView] = useState(View.Initial);

    return (
        <InformationModal open={open} maxWidth='xs' fullWidth onClose={onClose}>
            <img src={PASSWORD_CHANGE} alt={t(T_KEYS.TITLE)} className='tw-mx-auto tw-mb-8' />
            {view === View.Initial &&
                <div className='tw-text-center'>
                    <div className='tw-mb-4 tw-text-lg'>{t(T_KEYS.TITLE)}</div>
                    <PasswordChangedAt user={localUser} className='tw-justify-center tw-mb-8' />
                    <Button color='primary' onClick={() => setView(View.PasswordForm)}>{t(T_KEYS.CHANGE_PASSWORD)}</Button>
                </div>}
            {view === View.PasswordForm &&
                <Fragment>
                    <div className='tw-mb-4 tw-text-lg'>{t(T_KEYS.FORM_HEADER)}</div>
                    <ChangePassword onSuccess={onClose} />
                </Fragment>}
        </InformationModal>
    );
};